module.exports = __webpack_public_path__ + "img/tv.28ad8619.png";